import { useState } from "react";
import AddAttestationService from "./AddAttestationService";
import DeliveryInformation from "./DeliveryInformation";
import Payment from "./Payment";
import ShipperInformation from "./ShipperInformation";
import Stepper from "./Stepper";

const MainStepperAttestation = () => {

    const [page, setPage] = useState(0);
    return(
        <>
        <div className="outer-wrapper">
    <div className="inner-wrapper  items-center">
        <div className="bg-[#efefef] flex flex-col justify-center items-center min-h-[180px] py-[2rem] ">
          <h1 className="text-[30px] sm:text-[40px] font-bold ">Booking</h1>
        </div>
    </div>
  </div>

  <Stepper/>

        {page == 0 && <ShipperInformation/>}
        {page == 1 && <DeliveryInformation/>}
        {page == 2 && <AddAttestationService/>}
        {page == 3 && <Payment/>}
    

        
        
        </>
    );
};
export default MainStepperAttestation;